import Reflux from 'reflux';

let AlertActions = Reflux.createActions(['addAlert', 'closeAlert']);

export default AlertActions;



/** WEBPACK FOOTER **
 ** ./app/actions/alertActions.jsx
 **/